import CreateNewLoanApplication from "components/loans/CreateNewLoanApplication/CreateNewLoanApplication";
import DashboardLayout from "components/layout/DashboardLayout";
import Analytics from "pages/Analytics";
import Origination from "pages/Analytics/Origination";
import Borrower from "pages/Borrower";
import Borrowers from "pages/Borrowers";
import Company from "pages/Company";
import Dashboard from "pages/Dashboard";
import Document from "pages/Document";
import Documents from "pages/Documents";
import Loan from "pages/Loan";
import { Loans } from "pages/Loans/loans";
import Messages from "pages/Messages";
import Notifications from "pages/Notifications";
import Settings from "pages/Settings";
import AccountSettings from "pages/Settings/AccountSettings";
import BrandSettings from "pages/Settings/BrandSettings";
import NotificationSettings from "pages/Settings/NotificationSettings";
import UserPermissions from "pages/Settings/UserPermissions";
import { ChecklistSettings } from "pages/Settings/ChecklistSettings";
import { LoanProvider } from "providers/loan";
import { LoansProvider } from "providers/loans";
import { Navigate, Route, Routes } from "react-router-dom";
import Properties from "pages/Properties";
import { checkUiConfiguration } from "utils/uiconfighelper";
import IntegrationSettings from "pages/Settings/IntegrationSettings";
import { FieldSettings } from "pages/Settings/FieldSettings/field-settings";
import { FieldSettingsWithSections } from "pages/Settings/FieldSettings/field-settings-with-sections";
import { Revenue } from "pages/Phoenix/Analytics/revenue";
import { Entity } from "components/entities/entity";
import { Property } from "components/properties/property";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { Dashboard as TransactionsDashboard } from "modules/transactions/pages/dashboard";
import { Payments } from "modules/transactions/pages/payments";
import { Fees } from "modules/transactions/pages/fees";
import { Statements } from "modules/transactions/pages/statements";
import { Draws } from "modules/transactions/pages/draws";
import { useFeatures } from "hooks/useFeatures";

export function DashboardRoutes() {
  const { user } = useTenant();
  const { hasFeature } = useFeatures();

  if (!user) {
    return null;
  }

  function isLoanSectionEnabled() {
    return checkUiConfiguration(user, "loan_section");
  }

  return (
    <DashboardLayout>
      <LoansProvider>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/loans/application" element={<CreateNewLoanApplication />} />

          <Route path="/loans" element={<Loans />} />
          <Route
            path="/loans/:id"
            element={
              <LoanProvider>
                <Loan />
              </LoanProvider>
            }
          />

          <Route path="/borrowers" element={<Borrowers />} />
          <Route path="/borrowers/:id" element={<Borrower />} />

          {user.type === "lender" && hasFeature("transactions") && (
            <Route path="/transactions/*">
              <Route path="" element={<TransactionsDashboard />} />
              <Route path="payments" element={<Payments />} />
              <Route path="fees" element={<Fees />} />
              <Route path="statements" element={<Statements />} />
              <Route path="draws" element={<Draws />} />
            </Route>
          )}

          <Route path="/companies/:id" element={<Company />} />
          <Route path="/companies/:companyId/entities/:entityId" element={<Entity />} />
          <Route path="/companies/:companyId/properties/:propertyId" element={<Property />} />

          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:propertyId" element={<Property />} />

          <Route path="/documents" element={<Documents />} />
          <Route path="/documents/:id" element={<Document />} />

          <Route path="/messages" element={<Messages />} />
          <Route path="/messages/:id" element={<Messages />} />

          {user.type === "lender" && (
            <Route path="analytics/*">
              <Route path="" element={<Analytics />}>
                <Route path="origination" element={<Origination />} />
              </Route>
              {hasFeature("analytics_revenue") && <Route path="revenue" element={<Revenue />} />}
            </Route>
          )}

          <Route path="settings/*" element={<Settings />}>
            <Route path="account" element={<AccountSettings />} />
            <Route path="permissions" element={<UserPermissions />} />
            <Route path="notifications" element={<NotificationSettings />} />
            <Route path="checklist" element={<ChecklistSettings />} />
            <Route
              path="fields"
              element={isLoanSectionEnabled() ? <FieldSettingsWithSections /> : <FieldSettings />}
            />
            <Route path="integrations" element={<IntegrationSettings />} />
            <Route path="branding" element={<BrandSettings />} />
            <Route path="*" element={<Navigate to="account" />} />
          </Route>
          <Route path="/notifications" element={<Notifications />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </LoansProvider>
    </DashboardLayout>
  );
}
